import React, { FC, useContext } from 'react'

import { styled } from '@linaria/react'
import { Link } from 'react-router-dom'

import { ProfileNextContext } from 'components/block/Profile/ProfileMain/context/ProfileNextContext'
import { useStoreFrontGiftsUrl } from 'components/block/Profile/ProfileMain/hooks/useStoreFrontGiftsUrl'
import { MultiLikeSvg } from 'components/designSystem/svgr/MultiLikeSvg'
import { mergeAllUrls } from 'functions/mergeAllUrls'

export const MultiButton: FC = () => {
  const { profileId } = useContext(ProfileNextContext)
  const storeFrontGiftPath = useStoreFrontGiftsUrl(profileId!)

  return (
    <Parent
      to={mergeAllUrls(storeFrontGiftPath)}
      data-name="multi-button-action"
    >
      <Icon />
    </Parent>
  )
}

const Parent = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 64px;
  width: 64px;
  position: relative;
  filter: none;
`

const Icon = styled(MultiLikeSvg)`
  position: relative;
  z-index: 2;
`
